import React from "react";
import success from "../images/Success.png";
import "./PaymentMode.scss";
import { ButtonCustom } from "../UI/ButtonCustom/ButtonCustom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { formatDateTime } from "../common/commonFunctions";

function PaymentDetails() {
  const location = useLocation();
  const payDetails = location.state;
  const userDetails = useSelector((state) => state?.user?.user); // Adjust according to your actual state

  const handleDoneClick = () => {
    const redirectUrl = userDetails?.redirect_url || "https://google.com";
    if (redirectUrl) {
      localStorage.clear();
      window.location.replace(redirectUrl); // This will navigate to the new domain
    }
  };
  return (
    <div className="container">
      <div className="details commonBG">
        <img src={success} alt="" />
        <h3>Thank you for Choosing Triskel Pay</h3>
        <div className="details_inner">
          <div>
            <h5>Amount</h5>
            <p>
              {payDetails?.amount} {userDetails?.crypto}= $
              {payDetails?.amount_in_usd}
            </p>
          </div>
          <div>
            <h5>Address</h5>
            <p>{payDetails?.to_address}</p>
          </div>
          <div>
            <h5>Payment Mode</h5>
            <p>Triskel Pay</p>
          </div>
          <div>
            <h5>Purchased On</h5>
            <p>{formatDateTime(payDetails?.created_at)}</p>
          </div>
        </div>
        <ButtonCustom basicBtn label="Done" onClick={handleDoneClick} />
      </div>
    </div>
  );
}

export default PaymentDetails;
